import Vue from 'vue';
import { VAppBar, VToolbar } from 'vuetify/lib'

export default Vue.extend({
  mixins: [VAppBar],
  props: {
    descriptionHeight: Number
  },
  computed: {
    computedHeight () {
      const height = VToolbar.options.computed.computedHeight.call(this)
  
      return height + this.computedDescriptionHeight
    },
  
    computedOriginalHeight () {
      let height = VToolbar.options.computed.computedContentHeight.call(this)
      if (this.isExtended) height += parseInt(this.extensionHeight)
      return height
    },
  
    computedContentHeight () {
      if (!this.shrinkOnScroll) return VToolbar.options.computed.computedContentHeight.call(this)
      const height = this.computedOriginalHeight

      const min = 70
      
      if(this.computedScrollThreshold <= 0) {
        return min
      }

      const max = height
      const difference = max - min
      const iteration = difference / this.computedScrollThreshold
      const offset = this.currentScroll * iteration

      const result = Math.max(min, max - offset)
      return result
    },

    computedScrollThreshold () {
      if (this.scrollThreshold) return Number(this.scrollThreshold)
      return this.computedOriginalHeight - 70 + this.descriptionHeight
    },

    classes () {
      return {
        ...VToolbar.options.computed.classes.call(this),
        'v-toolbar--collapse': this.collapse || this.collapseOnScroll,
        'v-app-bar': true,
        'v-app-bar--clipped': this.clippedLeft || this.clippedRight,
        'v-app-bar--fade-img-on-scroll': this.fadeImgOnScroll,
        'v-app-bar--elevate-on-scroll': this.elevateOnScroll,
        'v-app-bar--fixed': !this.absolute && (this.app || this.fixed),
        'v-app-bar--hide-shadow': this.hideShadow,
        'v-app-bar--is-scrolled': true,
        'v-app-bar--shrink-on-scroll': this.shrinkOnScroll
      }
    },

    computedFontSize () {
      if (!this.isProminent) return undefined

      const min = 70
      const difference = this.computedContentHeight - min
      const increment = 0.003

      // 1.5rem to a minimum of 1.25rem
      const result = Number((1.96 + difference * increment).toFixed(2))
      return result
    },
    
    computedDescriptionOpacity () {
      if(this.computedScrollThreshold <= 0) {
        return 0
      }
      const opacity = Math.max((this.computedScrollThreshold - this.currentScroll) / this.computedScrollThreshold, 0)
      return Number(opacity.toFixed(2))
    },

    computedDescriptionHeight() {
      return this.descriptionHeight * this.computedDescriptionOpacity
    }
  },

  methods: {

    onScroll () {
      if (!this.canScroll) return

      this.previousScroll = this.currentScroll
      this.currentScroll = this.target
        ? this.target.scrollTop
        : window.pageYOffset

      this.isScrollingUp = this.currentScroll < this.previousScroll
      this.currentThreshold = Math.abs(this.currentScroll - this.computedScrollThreshold)
    },
    updateApplication () {
      return this.invertedScroll
        ? 0
        : this.computedOriginalHeight + this.descriptionHeight
    },

    genDescription() {
      return this.$createElement('div', {
          staticClass: 'v-toolbar__extension',
          style: {
            height: this.convertToUnit(this.computedDescriptionHeight),
            opacity: this.computedDescriptionOpacity
          },
      }, this.getSlot(this, 'description'))
    },

    getSlot (vm, name = 'default', data, optional = false) {
      if (vm.$scopedSlots[name]) {
        return vm.$scopedSlots[name](data instanceof Function ? data() : data)
      } else if (vm.$slots[name] && (!data || optional)) {
        return vm.$slots[name]
      }
      return undefined
    },

    convertToUnit (str, unit = 'px') {
      if (str == null || str === '') {
        return undefined
      } else if (isNaN(+str)) {
        return String(str)
      } else {
        return `${Number(str)}${unit}`
      }
    }
  },
    
  render (h) {
    this.isExtended = this.extended || !!this.$scopedSlots.extension

    const children = [this.genContent()]
    const data = this.setBackgroundColor(this.color, {
      class: this.classes,
      style: this.styles,
      on: this.$listeners,
    })

    if (this.isExtended) children.push(this.genExtension())
    
    children.push(this.genDescription())

    if (this.src || this.$scopedSlots.img) children.unshift(this.genBackground())

    const render = h(this.tag, data, children)
    
    render.data = render.data || {}

    if (this.canScroll) {
      render.data.directives = render.data.directives || []
      render.data.directives.push({
        arg: this.scrollTarget,
        name: 'scroll',
        value: this.onScroll,
        options: {capture: true}
      })
    }

    return render
  }
})